import { SvgIcon } from '@mui/material';

export const ChatArrowLeftIcon = () => {
  return (
    <SvgIcon width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0611 4.8295C12.5005 5.26884 12.5005 5.98116 12.0611 6.4205L7.23162 11.25H21.0156C21.6369 11.25 22.1406 11.7537 22.1406 12.375C22.1406 12.9963 21.6369 13.5 21.0156 13.5H7.23162L12.0611 18.3295C12.5005 18.7688 12.5005 19.4812 12.0611 19.9205C11.6218 20.3598 10.9095 20.3598 10.4701 19.9205L3.72013 13.1705C3.28079 12.7312 3.28079 12.0188 3.72013 11.5795L10.4701 4.8295C10.9095 4.39017 11.6218 4.39017 12.0611 4.8295Z"
        fill="#AFAFAF"
      />
    </SvgIcon>
  );
};
